import { render } from "./IngestStatus.vue?vue&type=template&id=8c8c8cb8"
import script from "./IngestStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./IngestStatus.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamSidebar/IngestStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8c8c8cb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8c8c8cb8', __exports__)) {
    api.reload('8c8c8cb8', __exports__)
  }
  
  module.hot.accept("./IngestStatus.vue?vue&type=template&id=8c8c8cb8", () => {
    api.rerender('8c8c8cb8', render)
  })

}


export default __exports__